<nav class="fixed-menu js_fixed_navigation {{ fixedNavbarClass }}">
    <section class="section fixed-menu__inner">

        <!--Mobile menu-->
        <div class="__new__header__mobile-button js-header-menu-adaptive __new__header--fixed">
            <div class="__new__header__mobile-button__icon" (touchstart)="showMobileMenu()">
                <img ngSrc="./img/design/common/header/hamburger.svg" alt="Меню" width="40" height="40">
            </div>
            <div class="__new__header__mobile-button__icon __new__header__mobile-button__icon--closet">
                <img ngSrc="./img/design/common/header/header-more-close.svg" alt="Меню" width="40" height="40">
            </div>
            <div class="__new__header__mobile-button__text">Меню</div>
        </div>

        <div class="fixed-menu__links">
            <ng-container *ngFor="let menuItem of menuItems">
                <a href="{{ menuItem.href }}" class="__new__header__menu-link" [attr.data-menu]="menuItem.id">{{ menuItem.title }}</a>
            </ng-container>
        </div>

        <div class="fixed-menu__services __new__header__top2024">

          <ng-container *ngIf="isOldHeader()">
            <a href="//client.ndv.ru/authentication/start" class="__new__header__top-buttons__link">
              <img ngSrc="/assets/images/svg/header/userRed.svg" alt="Войти" width="20" height="20">
            </a>

            <a href="/favorites"
               class="__new__header__top-buttons__link __new__header__top-buttons__link--fixed __new__header__top-buttons__link--favorite js-favoriteLink {{getNoFavouritesClass()}}">
              <img ngSrc="/assets/images/svg/header/heartRed.svg" alt="Избранное" width="20" height="20">
              <span class="__new__header__top-buttons__counter js_headerFavoritesCounter">{{ favouritesCount > 0 ? favouritesCount : '' }}</span>
            </a>
          </ng-container>

            <a (click)="showCalltouchWidget()" href="tel:+74959884422" class="__new__header__bottom-calls__phone">+7 (495) 988-44-22</a>

            <!--START Вызов и форма обратного звонка-->
            <a (click)="showCalltouchWidget()" class="__new__header__bottom-calls__me">
                Заказать звонок
              <img src="/assets/images/svg/call-order.svg" alt="Заказать звонок" width="16" height="16" class="__new__header__bottom-calls__me--icon">
            </a>
            <!-- Форма обратного звонка - итеграцию с calltouch -->
            <!--END Вызов и форма обратного звонка-->
        </div>
    </section>
</nav>
